import { __extends } from "tslib";
import { ReplyType } from './enums/reply-type.enum';
import { UGCItemBuilder } from './ugc-item.builder';
var ReplyBuilder = /** @class */ (function (_super) {
    __extends(ReplyBuilder, _super);
    function ReplyBuilder() {
        var _this = _super.call(this) || this;
        var ugcItem = new UGCItemBuilder().build();
        _this.item = ugcItem;
        _this.item.id = 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b';
        _this.item.type = ReplyType.USER;
        _this.item.ticketId = 'b1bb1b1b-b1b1-b1b1-b1b1-b1bb1bb1bb1b';
        return _this;
    }
    ReplyBuilder.prototype.withId = function (id) {
        this.item.id = id;
        return this;
    };
    ReplyBuilder.prototype.withEmailReadDate = function (date) {
        this.item.emailReadDate = date;
        return this;
    };
    ReplyBuilder.prototype.withTicketId = function (ticketId) {
        this.item.ticketId = ticketId;
        return this;
    };
    ReplyBuilder.prototype.withType = function (type) {
        this.item.type = type;
        return this;
    };
    ReplyBuilder.prototype.withRating = function (rating) {
        this.item.rating = rating;
        return this;
    };
    ReplyBuilder.prototype.withCcRecipients = function (ccRecipients) {
        this.item.ccRecipients = ccRecipients;
        return this;
    };
    ReplyBuilder.prototype.withAttachments = function (attachments) {
        this.item.attachments = attachments;
        return this;
    };
    ReplyBuilder.prototype.build = function () {
        return this.item;
    };
    return ReplyBuilder;
}(UGCItemBuilder));
export { ReplyBuilder };
//# sourceMappingURL=reply.builder.js.map